import type { UpdatePurchasePayload, UpdatePurchaseResponse } from "@api/updatePurchase";
import { updatePurchase } from "@api/updatePurchase";
import { useMutation } from "@tanstack/react-query";

type UseUpdatePurchaseOptions = {
  onSuccess?: (data: UpdatePurchaseResponse) => void;
};

export const useUpdatePurchase = (options?: UseUpdatePurchaseOptions) =>
  useMutation<{ data: UpdatePurchaseResponse; error?: string }, Error, UpdatePurchasePayload>({
    mutationFn: updatePurchase,
    onSuccess: (response) => {
      if (response?.data && options?.onSuccess) {
        options.onSuccess(response.data);
      }
    },
  });
